// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UploadDragImage_main__y7iDQ {
    width: 100%;
    height: 100%;
}

.UploadDragImage_custome_upload__K292h {
    width: 100%;
    height: 100%;
}

.UploadDragImage_custome_upload__K292h .ant-upload-drag-container {
    position: relative;
    width: 100%;  /* 或者指定具体的宽度 */
    height: 100%; /* 或者指定具体的高度 */
    overflow: hidden;  /* 确保图片不会溢出 */
}

.UploadDragImage_image_preview__T8Clw {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;  /* 使图片按比例缩放并居中 */
}

.UploadDragImage_upload_text__o8\\+jV {
    font-size: 20px;
    margin: 5px 0;
}

.UploadDragImage_min_text__VsGCV {
    margin: 5px 0;
    font-size: 12px;
    color: #aaa;
}
`, "",{"version":3,"sources":["webpack://./src/pages/imageSearch/components/UploadDragImage/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW,GAAG,cAAc;IAC5B,YAAY,EAAE,cAAc;IAC5B,gBAAgB,GAAG,aAAa;AACpC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,mBAAmB,GAAG,gBAAgB;AAC1C;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;AACf","sourcesContent":[".main {\n    width: 100%;\n    height: 100%;\n}\n\n.custome_upload {\n    width: 100%;\n    height: 100%;\n}\n\n.custome_upload :global(.ant-upload-drag-container) {\n    position: relative;\n    width: 100%;  /* 或者指定具体的宽度 */\n    height: 100%; /* 或者指定具体的高度 */\n    overflow: hidden;  /* 确保图片不会溢出 */\n}\n\n.image_preview {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;  /* 使图片按比例缩放并居中 */\n}\n\n.upload_text {\n    font-size: 20px;\n    margin: 5px 0;\n}\n\n.min_text {\n    margin: 5px 0;\n    font-size: 12px;\n    color: #aaa;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `UploadDragImage_main__y7iDQ`,
	"custome_upload": `UploadDragImage_custome_upload__K292h`,
	"image_preview": `UploadDragImage_image_preview__T8Clw`,
	"upload_text": `UploadDragImage_upload_text__o8+jV`,
	"min_text": `UploadDragImage_min_text__VsGCV`
};
export default ___CSS_LOADER_EXPORT___;
